export default {
  filters: {
    /**
     * 隐藏手机
     * 规则: 前3后4
     *
     * 日志：
     * * * @date 2019/11/26 17:16
     * * * @description 改为前3后4
     *
     * @param phone {string | number} 手机号
     * @return {string}
     */
    hidePhone (phone) {
      phone = (phone || '') + ''
      return `${phone.substring(0, 3)}****${phone.substring(7)}`
    },
    /**
     * 隐藏email
     * 规则: 前1后1 a*******1@xxx.com
     * @param email {string}
     * @return {string}
     */
    hideEmail (email='') {
      email = email ? email : ''
      let [name, field] = email.split('@')
      const nameLength = name.length
      const nameHideLength = nameLength - 1
      let hideStr = ''
      for (let i = 0; i < nameHideLength-1; i++) {
        hideStr += '*'
      }
      return email === '' ?
        '' : `${name.substring(0, 1)}${hideStr}${name.substring(nameHideLength)}@${field}`
    },
  }
}
